import { createContext } from 'react';

const TradeContext = createContext();

export default TradeContext;